import { render, staticRenderFns } from "./IcoArrowUpDown.vue?vue&type=template&id=0c0955ed"
import script from "./IcoArrowUpDown.vue?vue&type=script&lang=js"
export * from "./IcoArrowUpDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports